var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.078125,
    width: 24.0525,
    height: 24,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89205 9.79688C10.0995 9.79688 10.2676 9.96461 10.2676 10.1716V17.2535C10.2676 17.4604 10.0995 17.6282 9.89205 17.6282C9.68463 17.6282 9.51652 17.4604 9.51652 17.2535V10.1716C9.51652 9.96461 9.68463 9.79688 9.89205 9.79688Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3237 9.79688C14.5311 9.79688 14.6992 9.96461 14.6992 10.1716V17.2535C14.6992 17.4604 14.5311 17.6282 14.3237 17.6282C14.1163 17.6282 13.9482 17.4604 13.9482 17.2535V10.1716C13.9482 9.96461 14.1163 9.79688 14.3237 9.79688Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5531 8.76335V17.9953C17.5531 18.541 17.3525 19.0534 17.0023 19.4211C16.6536 19.7898 16.1683 19.9991 15.6605 20H8.55542C8.04743 19.9991 7.56218 19.7898 7.21365 19.4211C6.86335 19.0534 6.66283 18.541 6.66283 17.9953V8.76335C5.96649 8.57893 5.51527 7.90768 5.60842 7.19471C5.70172 6.48189 6.31033 5.94867 7.03087 5.94852H8.95354V5.48014C8.95133 5.08626 9.10741 4.70804 9.38686 4.42979C9.6663 4.15169 10.0459 3.99683 10.4407 4.00005H13.7752C14.17 3.99683 14.5496 4.15169 14.829 4.42979C15.1085 4.70804 15.2646 5.08626 15.2624 5.48014V5.94852H17.185C17.9056 5.94867 18.5142 6.48189 18.6075 7.19471C18.7006 7.90768 18.2494 8.57893 17.5531 8.76335ZM8.55542 19.2506H15.6605C16.3025 19.2506 16.802 18.7002 16.802 17.9953V8.79629H7.41388V17.9953C7.41388 18.7002 7.91336 19.2506 8.55542 19.2506ZM14.5113 5.48014C14.5138 5.28503 14.4369 5.09724 14.2982 4.9595C14.1596 4.82177 13.9709 4.74609 13.7752 4.74946H10.4407C10.245 4.74609 10.0563 4.82177 9.91773 4.9595C9.77896 5.09709 9.70209 5.28503 9.70459 5.48014V5.94852H14.5113V5.48014ZM17.185 6.69793H7.03087C6.65755 6.69793 6.35493 6.99989 6.35493 7.3724C6.35493 7.74491 6.65755 8.04687 7.03087 8.04687H17.185C17.5584 8.04687 17.861 7.74491 17.861 7.3724C17.861 6.99989 17.5584 6.69793 17.185 6.69793Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1079 9.79688C12.3153 9.79688 12.4834 9.96461 12.4834 10.1716V17.2535C12.4834 17.4604 12.3153 17.6282 12.1079 17.6282C11.9005 17.6282 11.7323 17.4604 11.7323 17.2535V10.1716C11.7323 9.96461 11.9005 9.79688 12.1079 9.79688Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.035,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 20.1216 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f0aade661f44118686363e4fab53f985.svg";
export { ForwardRef as ReactComponent };